// src/components/Navbar/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePlaces } from '../../context/PlaceContext';
import AccountMenu from '../AccountMenu/AccountMenu'; // New import
import './Navbar.css';

const Navbar = () => {
  const { authLoading } = useAuth();
  const { clearPrimaryPlace } = usePlaces() || {};

  // If auth is still loading, show minimal or nothing to avoid flicker
  if (authLoading) {
    return (
      <nav className="navbar">
        <Link
          to="/"
          className="navbar-brand"
          onClick={() => {
            if (clearPrimaryPlace) {
              clearPrimaryPlace();
            }
          }}
        >
          isLike
        </Link>
        <div className="navbar-links"></div>
      </nav>
    );
  }

  return (
    <nav className="navbar">
      <Link
        to="/"
        className="navbar-brand"
        onClick={() => {
          if (clearPrimaryPlace) {
            clearPrimaryPlace();
          }
        }}
      >
        isLike
      </Link>

      <div className="navbar-links">
        {/* Replace the old links with our new AccountMenu */}
        <AccountMenu />
      </div>
    </nav>
  );
};

export default Navbar;